var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExceedalcohollimit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1426 17L12.1426 15M12.1426 15L14.1425 13M12.1426 15L10.1426 13M12.1426 15L14.1425 17M13.1426 3.00087C13.0471 3 12.9399 3 12.8173 3H8.34277C7.22267 3 6.6622 3 6.23438 3.21799C5.85805 3.40973 5.55231 3.71547 5.36056 4.0918C5.14258 4.51962 5.14258 5.08009 5.14258 6.2002V17.8002C5.14258 18.9203 5.14258 19.4801 5.36057 19.9079C5.55231 20.2842 5.85805 20.5905 6.23438 20.7822C6.66178 21 7.22158 21 8.33952 21L15.9457 21C17.0636 21 17.6226 21 18.05 20.7822C18.4263 20.5905 18.7331 20.2842 18.9248 19.9079C19.1426 19.4805 19.1426 18.9215 19.1426 17.8036V9.32568C19.1426 9.20296 19.1426 9.09561 19.1416 9M13.1426 3.00087C13.4282 3.00347 13.6089 3.01385 13.7814 3.05526C13.9855 3.10425 14.1804 3.18526 14.3594 3.29492C14.5611 3.41857 14.7344 3.59182 15.0801 3.9375L18.2056 7.06298C18.5515 7.40889 18.7234 7.58136 18.8471 7.78319C18.9568 7.96214 19.0379 8.15726 19.0869 8.36133C19.1283 8.53376 19.1389 8.71451 19.1416 9M13.1426 3.00087V5.8C13.1426 6.9201 13.1426 7.47977 13.3606 7.90759C13.5523 8.28392 13.8581 8.59048 14.2344 8.78223C14.6618 9 15.2216 9 16.3395 9H19.1416M19.1416 9H19.1428",
    stroke: "#DE0000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExceedalcohollimit);
export default __webpack_public_path__ + "static/media/exceedalcohollimit.4a52e220f51a8b5643884b7f9d5d64fa.svg";
export { ForwardRef as ReactComponent };